<template lang="pug">
.footer-container
    transition(name="fade")
        a.back-to-top.is-mobile(@click="scrollTop" v-show="visible")
            i.fas.fa-angle-up

    a.to-top.is-desktop(@click="scrollTop")
        p Back to Top 
            i.fas.fa-angle-up
    footer.footer
        .content
        p &copy; 2021 Wi-Monitor
</template>

<script>
export default {
    data () {
        return {
            visible: false
        }
    },
    methods: {
        scrollTop: function () {
            const target = document.querySelector('.main')
            target.scrollTo({
                top: 0,
                behavior: "smooth"
            });
        },
        scrollListener: function () {
            const target = document.querySelector('.main')
            this.visible = target.scrollTop > 150
        }
    },
    mounted() {
        const target = document.querySelector('.main')
        if(target){
            target.addEventListener('scroll', this.scrollListener)
        }
    },
    beforeDestroy() {
        const target = document.querySelector('.main')
        if(target){
            target.removeEventListener('scroll', this.scrollListener)
        }
    }
}
</script>

<style scoped lang="stylus">
.footer-container
    width 100%
    height footer-height
    background-color main-color

.to-top
    text-align center
    color text-color
    display block
    height 32px

.back-to-top
    width 58px
    height 58px
    padding 16px
    background-color text-color
    position fixed
    right 16px
    bottom 24px
    color bg-color
    border-radius 50%
    border 1px solid main-color
    center-align()
    &:hover
        color middle-color

footer.footer
    border-top 1px solid text-color
    padding 1rem 1.5rem 1rem
    background-color main-color
    height footer-height
    .content
        margin 0 auto
        font-size .8em

.is-desktop
    display block
.is-mobile
    display none

+tb()
    .is-desktop
        display none
    .is-mobile
        display flex
</style>